import { app } from 'utils/appEnv';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const HIDE_DURATION_MS = 5 * 60 * 1000;

interface EnvironmentIndicatorState {
  hiddenUntil: number | null;
  hideForFiveMinutes: () => void;
  shouldShow: () => boolean;
}

export const useEnvironmentIndicatorStore = create<EnvironmentIndicatorState>()(
  persist(
    (set, get) => ({
      hiddenUntil: null,
      hideForFiveMinutes: () => {
        const fiveMinutesFromNow = Date.now() + HIDE_DURATION_MS;
        set({ hiddenUntil: fiveMinutesFromNow });
      },
      shouldShow: () => {
        if (app.env === 'production') return false;
        const { hiddenUntil } = get();
        return hiddenUntil === null || Date.now() > hiddenUntil;
      },
    }),
    {
      name: 'environment-indicator-storage',
    }
  )
);
